"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeAnnotationSelection = exports.serializeAnnotationSelection = exports.isResetAction = exports.AnnotatedContentUpdateType = exports.UserType = exports.isAnnotationSelection = void 0;
const isAnnotationSelection = (x) => {
    return (typeof x === 'object' &&
        x !== null &&
        'start' in x &&
        'end' in x &&
        isAnnotationPoint(x.start) &&
        isAnnotationPoint(x.end));
};
exports.isAnnotationSelection = isAnnotationSelection;
const isAnnotationPoint = (x) => {
    return (typeof x === 'object' &&
        x !== null &&
        'textNodeId' in x &&
        'characterIndex' in x);
};
var UserType;
(function (UserType) {
    UserType["student"] = "Student";
    UserType["instructor"] = "Instructor";
})(UserType || (exports.UserType = UserType = {}));
var AnnotatedContentUpdateType;
(function (AnnotatedContentUpdateType) {
    AnnotatedContentUpdateType["starSection"] = "starSection";
    AnnotatedContentUpdateType["unstarSection"] = "unstarSection";
    AnnotatedContentUpdateType["createCommentThread"] = "createCommentThread";
    AnnotatedContentUpdateType["addComment"] = "addComment";
    AnnotatedContentUpdateType["likeComment"] = "likeComment";
    AnnotatedContentUpdateType["unLikeComment"] = "unLikeComment";
})(AnnotatedContentUpdateType || (exports.AnnotatedContentUpdateType = AnnotatedContentUpdateType = {}));
const isResetAction = (localAnnotatedContentUpdateAction) => {
    return !('type' in localAnnotatedContentUpdateAction);
};
exports.isResetAction = isResetAction;
const serializeAnnotationSelection = (annotationSelection) => JSON.stringify(annotationSelection);
exports.serializeAnnotationSelection = serializeAnnotationSelection;
const deserializeAnnotationSelection = (serializedAnnotationSelection) => JSON.parse(serializedAnnotationSelection);
exports.deserializeAnnotationSelection = deserializeAnnotationSelection;
//# sourceMappingURL=AnnotatedContent.types.js.map